module.exports = __webpack_public_path__ + "static/img/12.09746435.png";